import { type FunctionComponent } from 'react';
import { MaybeLink } from '../../common-components/link/link.component';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { brandLogo } from './brand-logo.css';

export type BrandLogoProps = {
	brandName: string;
	imageId: string;
	url?: string | null;
	bypassLazyLoad?: boolean;
};

export const BrandLogo: FunctionComponent<BrandLogoProps> = ({ brandName, url, imageId, bypassLazyLoad = false }) => (
	<div className={`${brandLogo} center dn flex-ns justify-center`} data-testid="brand-logo">
		<MaybeLink url={url} underline={false}>
			<CloudinaryImage publicID={imageId} description={brandName} options={{ width: 0, height: 0 }} bypassLazyLoad={bypassLazyLoad} />
		</MaybeLink>
	</div>
);
